<template>
  <a-drawer
      :title="title"
      :maskClosable="true"
      width=650
      placement="right"
      :closable="true"
      @close="close"
      :visible="visible"
      style="overflow: auto;padding-bottom: 53px;">
    <a-tree
        v-model="checkedKeys"
        checkable
        :expanded-keys="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :selected-keys="selectedKeys"
        :tree-data="treeData"
        @expand="onExpand"
        @select="onSelect"
    />

    <div class="drawer-bottom-button">
      <a-button style="margin-right: 0.8rem" @click="close">
        取消
      </a-button>
      <a-button type="primary" @click="ok">
        授权
      </a-button>
    </div>

  </a-drawer>
</template>

<script>


import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "RolePermissionModal",
  mixins: [HttpMixins],
  data() {
    return {
      title: "角色权限配置",
      visible: false,
      record: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      treeData: [],
      url: {
        tree: window._CONFIG['domainURL'] + "/permission/tree",
        edit: window._CONFIG['domainURL'] + "/role"
      }
    }
  },
  watch: {
    checkedKeys(val) {
      console.log('onCheck', val);
    },
  },
  methods: {

    show(record) {
      this.visible = true;
      this.record = record;
      if (record.permissions) {
        this.checkedKeys = record.permissions.split(",");
      } else {
        this.checkedKeys = [];
      }
      this.loadData();
    },

    loadData() {
      let that = this;
      that.$axios.get(that.url.tree, {headers: that.headers}).then((res) => {
        that.treeData = res.data;
      })
    },

    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },

    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys;
    },
    close() {
      this.visible = false;
    },
    ok() {
      let that = this;
      let param = {};
      param.id = that.record.id;
      param.permissions = that.checkedKeys.join(",");
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success("授权成功");
            that.close();
            that.$emit('ok');
          } else {
            that.$message.error(response.msg);
          }
        }
      }
      that.$axios.put(that.url.edit, param, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    }
  }
}
</script>

<style scoped>

</style>
